import { render, staticRenderFns } from "./Transport.vue?vue&type=template&id=2bf49acc&"
import script from "./Transport.vue?vue&type=script&lang=js&"
export * from "./Transport.vue?vue&type=script&lang=js&"
import style0 from "./Transport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports